<template>
  <div class="scoped-box">
    <div class="item" v-for="item in list" :key="item.id">
      <Card :title="item.code" :bordered="false" dis-hover>
        <Button slot="extra" size="small" icon="md-download" type="primary" @click="onPDF(item)" />
        <List size="small">
          <ListItem>
            <ListItemMeta :title="$t('name.ticket.before_money')" />
            <template slot="extra">
              {{ item.before_money }}
            </template>
          </ListItem>
          <ListItem>
            <ListItemMeta :title="$t('name.ticket.tax')" />
            <template slot="extra">
              {{ item.tax }}%
            </template>
          </ListItem>
          <ListItem>
            <ListItemMeta :title="$t('name.ticket.tax_money')" />
            <template slot="extra">
              {{ item.tax_money }}
            </template>
          </ListItem>
          <ListItem>
            <ListItemMeta :title="$t('name.ticket.money')" />
            <template slot="extra">
              <span class="money">{{ item.money }}</span>
            </template>
          </ListItem>
          <ListItem>
            <ListItemMeta :title="$t('name.ticket.created_at')" />
            <template slot="extra">
              <Time :time="item.created_at * 1000" type="date" />
            </template>
          </ListItem>
        </List>
      </Card>
    </div>
    <div class="empty" v-if="!list.length">{{ $t('message.empty') }}</div>
    <form ref="pdf_form" action="" method="post" target="_blank">
      <input ref="pdf_form_data" type="hidden" name="data" />
    </form>
  </div>
</template>
<script>
import { info } from '@/api/auth';
import { pdfTicket } from '@/api/plugin'

export default {
  props: {
    list: Array
  },
  data() {
    return {
      user: {}
    }
  },
  created() {
    info().then(res => {
      this.user = res
    })
  },
  methods: {
    onPDF(data) {
      // 附加用户信息
      data.user = Object.assign({}, this.user)
        
      // 使用插件
      let ticket = pdfTicket(data)
      
      this.$refs.pdf_form_data.value = ticket.data
      this.$refs.pdf_form.action = ticket.action
      this.$refs.pdf_form.submit()
    }
  }
};
</script>
<style lang="less" scoped>
  @import '@/style/app.less';
  
  .scoped-box{
    display: flex;
    flex-wrap: wrap;
    padding: 15px;
    
    .item{
      width: 25%;
      padding: 15px;
    }
    .money{
      color: @color;
      font-size: 16px;
    }
    
    .empty{
      padding: 50px;
      text-align: center;
      width: 100%;
    }
  }
</style>